var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 20.715,
    height: 16.639,
    fill: "#1c1c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__envios",
    transform: "translate(-0.272 -0.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    transform: "translate(0.272 0.061)",
    fill: "#fff",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_550",
    "data-name": "Grupo 550",
    transform: "translate(12.914 14.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M20.188,7.343,19.142,5.89a2.793,2.793,0,0,0-2.271-1.174h-4.2V2.8A2.8,2.8,0,0,0,9.879,0H2.8A2.8,2.8,0,0,0,0,2.8V12.9a1.781,1.781,0,0,0,1.779,1.779H2.806a2.533,2.533,0,0,0,4.936,0h5.228a2.534,2.534,0,0,0,4.937,0h1.028A1.781,1.781,0,0,0,20.714,12.9V8.965a2.814,2.814,0,0,0-.525-1.622m-1,1.622V12.9a.257.257,0,0,1-.254.254H17.8a2.548,2.548,0,0,0-4.726,0h-.4V6.241h4.2a1.292,1.292,0,0,1,1.034.535l1.044,1.449a1.306,1.306,0,0,1,.24.74m-3.751,6.4a.953.953,0,0,1-.094-.019A1.248,1.248,0,0,1,14.168,14.1c0-.036.018-.066.021-.1A1.265,1.265,0,0,1,15.28,12.86a1.219,1.219,0,0,1,.159-.033,1.271,1.271,0,0,1,0,2.541M11.149,2.8V13.152H7.638a2.548,2.548,0,0,0-4.727,0H1.779a.254.254,0,0,1-.254-.254V2.8A1.272,1.272,0,0,1,2.8,1.525H9.879A1.272,1.272,0,0,1,11.149,2.8M5.274,15.368a.953.953,0,0,1-.094-.019A1.248,1.248,0,0,1,4,14.1c0-.036.017-.066.02-.1A1.267,1.267,0,0,1,5.116,12.86a1.185,1.185,0,0,1,.159-.033,1.271,1.271,0,0,1,0,2.541",
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M16.264,7.14H14.231a.762.762,0,0,0,0,1.525h2.033a.762.762,0,1,0,0-1.525",
    transform: "translate(0.221 0.118)",
    fill: "#1c1c1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvios);
export default __webpack_public_path__ + "static/media/__envios.759c9cc0caaf22538dc42b76490e00f0.svg";
export { ForwardRef as ReactComponent };